import React, { useEffect, useState } from 'react';
import styles from '../css/FeedbackList.module.css';

const FeedbackList = () => {
	const [feedbacks, setFeedbacks] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		fetch('https://hometech-repairs.in/homeTech/get_feedback.php')
			.then((res) => res.json())
			.then((data) => {
				if (data.status) {
					setFeedbacks(data.data);
				} else {
					setError(data.msg || 'Failed to fetch feedback.');
				}
				setLoading(false);
			})
			.catch(() => {
				setError('Error fetching data.');
				setLoading(false);
			});
	}, []);

	if (loading) return <div className={styles.loader}>Loading feedback...</div>;
	if (error) return <div className={styles.error}>{error}</div>;

	return (
		<div className={styles.feedbackSection}>
			<h2 style={{color:'black'}}>Customer Feedback</h2>
			<div className={styles.feedbackRow}>
				{feedbacks.length === 0 ? (
					<p>No feedback found.</p>
				) : (
					feedbacks.map((fb) => (
						<div key={fb.id} className={styles.feedbackCard}>
							<p className={styles.date}>
								{(() => {
									const date = new Date(fb.submitted_at);
									const day = String(date.getDate()).padStart(2, '0');
									const month = String(date.getMonth() + 1).padStart(2, '0');
									const year = date.getFullYear();
									return `${day}-${month}-${year}`;
								})()}
							</p>

							<h3 className={styles.name}>{fb.name}</h3>
							<div className={styles.stars}>
								{Array.from({ length: Number(fb.rating) }, (_, i) => (
									<span key={i}>⭐</span>
								))}
							</div>
							<p className={styles.feedbackText}>"{fb.overall_experience}"</p>
							{fb.liked_most && <p>{fb.liked_most}</p>}
							{/*	{fb.improvement_suggestion && (
								<p>
									<strong>Suggestions:</strong> {fb.improvement_suggestion}
								</p>
							)} */}
							{/* <p>Recommend: {fb.recommend}</p> */}
						</div>
					))
				)}
			</div>
		</div>
	);
};

export default FeedbackList;
